import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Spinner, Alert, Button, Card, Modal } from 'react-bootstrap';

function ProductList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const getProducts = async () => {
    try {
      const res = await axios.get('https://apimyshop.myidealtd.co.uk/api/products', {
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' },
      });

      const productsArray = Array.isArray(res.data.products)
        ? res.data.products
        : res.data.Products || [];

      setData(productsArray);
      console.log("PRODUCTS:", productsArray);
    } catch (err) {
      setError('Error fetching products. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  const confirmDelete = (id) => {
    setSelectedProductId(id);
    setShowModal(true);
  };

  const handleDeleteConfirmed = async () => {
  try {
    const res = await axios.delete(
      `https://apimyshop.myidealtd.co.uk/api/products/delete/${selectedProductId}`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (res.status === 200) {
      console.log("Product deleted");

      // update UI instantly (better UX)
      setData(prev =>
        prev.filter(item => item._id !== selectedProductId)
      );
    }

  } catch (error) {
    console.error("Delete failed:");
    console.error("Status:", error.response?.status);
    console.error("Data:", error.response?.data);
  } finally {
    setShowModal(false);
    setSelectedProductId(null);
  }
};

  return (
    <div style={{ padding: '1rem' }}>
      {/* HEADER */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          marginBottom: '1.5rem'
        }}
      >
        <h3 style={{ marginBottom: '1rem' }}>Products</h3>

        <Link
          to="/AddProduct"
          title="Create Product"
          style={{
            width: '45px',
            height: '45px',
            backgroundColor: '#000',
            color: '#fff',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textDecoration: 'none',
            fontSize: '24px',
            marginBottom: '1rem'
          }}
        >
          +
        </Link>
      </div>

      {/* STATES */}
      {loading ? (
        <div style={{ textAlign: 'center', margin: '3rem 0' }}>
          <Spinner animation="border" variant="primary" />
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : data.length === 0 ? (
        <Alert variant="info">No products found.</Alert>
      ) : (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1rem'
          }}
        >
          {data.map((item) => {
            const images = Array.isArray(item.images) ? item.images : [];
            const mainImage = images.length > 0 ? images[0] : null;

            return (
              <div
                key={item._id}
                style={{
                  flex: '1 1 calc(33.333% - 1rem)',
                  maxWidth: 'calc(33.333% - 1rem)',
                  minWidth: '280px'
                }}
              >
                <Card
                  style={{
                    height: '100%',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: 'none',
                    borderRadius: '10px',
                    overflow: 'hidden'
                  }}
                >
                  {/* ✅ PROFESSIONAL IMAGE CONTAINER */}
                  <div
                    style={{
                      width: '100%',
                      height: '220px',
                      background: '#f8f9fa',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '10px'
                    }}
                  >
                    {mainImage ? (
                      <img
                        src={`https://apimyshop.myidealtd.co.uk/uploads/${mainImage}`}
                        alt=""
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <span style={{ color: '#999' }}>No Image</span>
                    )}
                  </div>

                  <Card.Body style={{ display: 'flex', flexDirection: 'column' }}>
                    <Card.Title style={{ color: '#0d6efd', fontWeight: 'bold' }}>
                      {item.name}
                    </Card.Title>

                    <Card.Text style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                      <strong>Brand:</strong> {item.brand} <br />
                      <strong>Category:</strong> {item.category} <br />
                      <strong>Price:</strong> £{item.price} <br />
                      <strong>Stock:</strong> {item.countInStock}
                    </Card.Text>

                    <Card.Text style={{ fontSize: '0.9rem', flexGrow: 1 }}>
                      {item.description}
                    </Card.Text>

                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 'auto'
                      }}
                    >
                      <Link to={`/edit/${item._id}`}>
                        <Button variant="outline-secondary" size="sm">
                          Edit
                        </Button>
                      </Link>

                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => confirmDelete(item._id)}
                      >
                        Delete
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            );
          })}
        </div>
      )}

      {/* DELETE MODAL */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete this product?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>

          <Button variant="danger" onClick={handleDeleteConfirmed}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ProductList;